@if (isAdmin) {
  <app-header></app-header>
}
<mat-sidenav-container class="sidebar-container">
  <mat-sidenav #sidenav mode="side" [mode]="isMobileScreen?'over':'side'" [opened]="(isUserLoggedIn && !isMobileScreen) || isAdmin"
    class="sidenav">
    <app-side-nav></app-side-nav>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <app-spinner></app-spinner>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (isAdmin) {
  <app-footer-common></app-footer-common>
}

<!-- Google Sign-in Popup Component -->
<app-google-signin-popup 
  [showAfterDelay]="3000"
  [autoShowOnPageLoad]="true"
  (onSignInAttempt)="onSignInAttempt($event)"
  (onPopupClosed)="onPopupClosed()">
</app-google-signin-popup>

